/**
 * #8 Refer a business — /refer-a-friend.
 * The Lead is the business being referred; the person referring is recorded
 * in the Note (and tagged) so the referral reward can be traced.
 */
import { company, email, phone } from "./common";

const referral = {
  id: "referral",
  label: "Refer a business",
  crm: { layout: "Standard", leadSource: "Website Referral", tags: ["Referral"] },
  steps: [
    {
      title: "About you",
      fields: [
        [
          { name: "referrer_name", type: "text", label: "Your name", required: true, errorName: "your name", autoComplete: "name" },
          { name: "referrer_email", type: "email", label: "Your email", required: true, errorName: "your email address", autoComplete: "email" },
        ],
        { name: "referrer_phone", type: "tel", label: "Your phone", autoComplete: "tel" },
      ],
    },
    {
      title: "The business you're referring",
      fields: [
        [
          { name: "contact_first_name", type: "text", label: "Contact first name", required: true, errorName: "their first name", crm: "First_Name", autoComplete: "off" },
          { name: "contact_last_name", type: "text", label: "Contact last name", crm: "Last_Name", autoComplete: "off" },
        ],
        { ...company, label: "Business name", required: true, errorName: "the business name", autoComplete: "off" },
        [
          { ...email, label: "Their email", errorName: "their email address", autoComplete: "off" },
          { ...phone, label: "Their phone", autoComplete: "off" },
        ],
        {
          name: "relationship", type: "select", label: "How do you know them?",
          options: ["Customer of mine", "Supplier", "Friend or family", "Other"].map((l) => ({ value: l, label: l })),
        },
        {
          name: "notes", type: "textarea", label: "Anything we should know?", crm: "Description", maxLength: 2000,
          placeholder: "e.g. what they sell, what they use now, best time to call",
        },
      ],
    },
  ],
  submitLabel: "Send referral",
  // The referred business hasn't agreed to marketing — never record an opt-in.
  consent: { variant: "notice", marketing: false },
  success: {
    title: "Thanks for the referral!",
    body: "We'll get in touch with them and keep you updated every step of the way.",
    allowReset: true,
    resetLabel: "Refer another business",
  },
  summary: (values) => `Referral from ${values.referrer_name || "a website visitor"}`,
};

export default referral;
